import path from "ramda/es/path";
import all from "ramda/es/all";
import any from "ramda/es/any";
import append from "ramda/es/append";
import apply from "ramda/es/apply";
import compose from "ramda/es/compose";
import concat from "ramda/es/concat";
import cond from "ramda/es/cond";
import filter from "ramda/es/filter";
import flatten from "ramda/es/flatten";
import flip from "ramda/es/flip";
import identity from "ramda/es/identity";
import includes from "ramda/es/includes";
import isNil from "ramda/es/isNil";
import map from "ramda/es/map";
import mergeRight from "ramda/es/mergeRight";
import none from "ramda/es/none";
import nth from "ramda/es/nth";
import o from "ramda/es/o";
import pair from "ramda/es/pair";
import prepend from "ramda/es/prepend";
import argumentsToList from "ramda-extension/es/argumentsToList";
import isArray from "ramda-extension/es/isArray";
import isFunction from "ramda-extension/es/isFunction";
const obtainFileLists = compose(flatten, map((input)=>document.getElementById(input).files));
const appendFilesToBody = map((file)=>(body)=>{
        body.append('files', file);
        return body;
    });
export const prepareMultipartData = (state)=>{
    const fileItemFromStore = map((fieldName)=>{
        const deepPath = path([
            'fieldDescriptor',
            fieldName,
            'deepPath'
        ], state);
        return path(prepend('formData', deepPath.split('.')), state);
    });
    const fileNamesFromStore = flatten(fileItemFromStore(state.fileInputs));
    const filterFiles = filter((f)=>includes(f, fileNamesFromStore));
    const body = new FormData();
    body.append('formData', JSON.stringify(state.formData));
    const appendFunctions = compose(identity, appendFilesToBody, filterFiles, obtainFileLists)(state.fileInputs);
    return compose(identity, ...appendFunctions)(body);
};
export const mergeWithResolveValueWithState = (left, right)=>{
    if (any(isFunction, [
        left,
        right
    ])) {
        return (state)=>mergeRight(isFunction(left) ? left(state) : left, isFunction(right) ? right(state) : right);
    } else {
        return mergeRight(left, right);
    }
};
export const mergeActions = compose(cond([
    [
        o(isNil, nth(0)),
        nth(1)
    ],
    [
        o(isNil, nth(1)),
        nth(0)
    ],
    [
        all(isArray),
        apply(concat)
    ],
    [
        none(isArray),
        apply(pair)
    ],
    [
        o(isArray, nth(0)),
        apply(flip(append))
    ],
    [
        o(isArray, nth(1)),
        apply(prepend)
    ]
]), argumentsToList);
